module.exports = {
    title: "Experience",
    crud: {
        create: "Create Experience",
        edit: "Edit Experience",
        view: "View Experience",
    },
    table: {
        title: "Title",
    },
    form: {
        title: "Title",

    },
    validation: {
        required: {
            title: 'Title is required',
        },
        minLength: {
            title: 'title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
